import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExpandCollapseStateService {
  isOpenMap: { [key: string]: boolean } = {};
  
  constructor() {
    this.isOpenMap = {};
  }

  isOpen(sectionId: string): boolean {
    return this.isOpenMap[sectionId];
  }
  
  toggleIsOpen(sectionId: string): void {
    this.isOpenMap[sectionId] = !this.isOpenMap[sectionId];
  }
  
}
